function Footer() {
  return (
    <footer className='relative flex flex-col gap-2 bg-white py-6 px-5 text-sm'>
      <p className='lg:text-center text-neutralColor-normal flex gap-4 lg:justify-center text-xs md:text-sm'>
        <a
          href='https://sein.tech/about'
          target='_blank'
          rel='noreferrer'
          className='hover:text-secondaryColor-normal cursor-pointer'
        >
          About
        </a>
        <a
          href='https://sein.tech/terms-of-use'
          target='_blank'
          rel='noreferrer'
          className='hover:text-secondaryColor-normal cursor-pointer'
        >
          Terms of use
        </a>
        <a
          href='https://sein.tech/privacy-policy'
          target='_blank'
          rel='noreferrer'
          className='hover:text-secondaryColor-normal cursor-pointer'
        >
          Privacy
        </a>
      </p>

      <p className='lg:mx-auto text-neutralColor-normal text-xs'>
        &#169; 2023 SEIN Technology Partners.
      </p>
    </footer>
  );
}

export default Footer;
